import { render, staticRenderFns } from "./GliLabel.vue?vue&type=template&id=f7c7c4e6&"
import script from "./GliLabel.vue?vue&type=script&lang=js&"
export * from "./GliLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports